// extracted by mini-css-extract-plugin
export default {"default":"Ygd2AnI8vn0MRdwLujjn","opened":"sSprZlkYnnLmYxfGT3S3","closed":"mpby8nYTXP_RLWGJPiEO"};